import React from 'react';

export const AuthorHelperContext = React.createContext(true);
